module.exports = __webpack_public_path__ + "media/generic_scholarship_search/scholarship_widget_fw_logo-a5ce29c3.png";